import _taggedTemplateLiteral from "@babel/runtime/helpers/taggedTemplateLiteral";

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n  fill: ", ";\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

import { SVGStyled } from '../shared';

/**
 * Base SVG "Fill" component
 *
 * @param props.as defaults to "path"; any valid SVG child element can be used.
 * @param props.svgColor fill color (if not set, relies on value from context)
 */
var SVGFill = SVGStyled.path(_templateObject(), function (_ref) {
  var svgColor = _ref.svgColor,
      theme = _ref.theme;
  return svgColor || theme.svgColor;
});
SVGFill.defaultProps = {
  role: 'presentation'
};
export default SVGFill;